import {
  EntityList,
  EntityListProps,
  renderDate,
  renderInvertedYesNoIcon,
  renderPersona,
  renderTimeAgo,
} from 'components/EntityList'
import { OrderId } from 'gql.generated'
import {
  ConstrainMode,
  PersonaSize,
  SelectionMode,
} from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

export type OrderIdListProps = EntityListProps<OrderId>

export const OrderIdList: React.FunctionComponent<OrderIdListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('inactive', {
        minWidth: 40,
        maxWidth: 40,
        name: t('field.active.label'),
        onRender: renderInvertedYesNoIcon,
        ungroupable: true,
      }),
      fieldColumn('value', {
        minWidth: 85,
        ungroupable: true,
        isSorted: true,
      }),
      fieldColumn('validFrom', {
        ungroupable: true,
        onRender: renderDate,
      }),
      fieldColumn('validTo', {
        ungroupable: true,
        onRender: renderDate,
      }),
      fieldColumn('modifiedBy', {
        onRender: renderPersona({
          size: PersonaSize.size8,
        }),
        minWidth: 155,
        ungroupable: true,
      }),
      fieldColumn('modified', {
        onRender: renderTimeAgo,
        ungroupable: true,
      }),
    ],
    [fieldColumn]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      onShouldVirtualize={() => true}
      {...props}
    />
  )
}
